import { useState } from 'react';

enum RequestStatusEnum {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export const useRequestStatus = () => {
  const [requestStatus, setRequestStatus] = useState<RequestStatusEnum>(
    RequestStatusEnum.NOT_STARTED
  );

  return {
    setCompleted: () => {
      setRequestStatus(RequestStatusEnum.COMPLETED);
    },
    setInProgress: () => {
      setRequestStatus(RequestStatusEnum.IN_PROGRESS);
    },
    setFailed: () => {
      setRequestStatus(RequestStatusEnum.FAILED);
    },
    setNotStarted: () => {
      setRequestStatus(RequestStatusEnum.NOT_STARTED);
    },

    isCompleted: requestStatus === RequestStatusEnum.COMPLETED,
    isInProgress: requestStatus === RequestStatusEnum.IN_PROGRESS,
    isFailed: requestStatus === RequestStatusEnum.FAILED,
    isNotStarted: requestStatus === RequestStatusEnum.NOT_STARTED,
    hasFinished:
      requestStatus === RequestStatusEnum.FAILED || requestStatus === RequestStatusEnum.COMPLETED,
    requestStatus,
  };
};
